export const sampleFinalReport = {
    overview: {
        finalGrade: "A",
        productivityScore: 91,
        productivityGrowth: 247,
    },

    stats: {
        total: 90,
        done: 82,
        planned: 6,
        cancelled: 2,
    },

    signals: {
        consistency: 92,
        focus: 88,
        discipline: 90,
        resilience: 84,
    },

    behavior: {
        roachType: "Phoenix Survivor",
    },

    comparison: {
        start: {
            productivity: 28,
        },
        middle: {
            productivity: 63,
        },
        end: {
            productivity: 91,
        },
    },

    objectives: {
        dominant: "Learning",

        distribution: {
            Learning: 28,
            Discipline: 22,
            Career: 16,
            Health: 10,
            Focus: 8,
            Growth: 6,
        },
    },

    strengths: [
        "Reduced gaming dependency from daily habit to controlled reward system.",
        "Built a consistent morning study routine.",
        "Developed strong reflection and self-awareness habits.",
        "Increased focus duration from 15 minutes to 90+ minutes.",
        "Maintained execution momentum through difficult weeks.",
    ],

    weaknesses: [
        "Occasional relapse during high stress periods.",
        "Deep work consistency still fluctuates on weekends.",
        "Physical health routines need stronger integration.",
    ],

    insights: [
        "Productivity improved by 247% across the 90-day cycle.",
        "Learning became the dominant identity driver.",
        "Behavior evolved from reactive execution to intentional execution.",
        "Discipline became increasingly stable after Week 6.",
        "The strongest transformation occurred in consistency and focus.",
    ],

    momentum: {
        start: 28,
        middle: 63,
        final: 91,
    },

    journey: {
        day0: 28,
        day45: 63,
        day90: 91,
    },
};